import { disableRootScrolling as e, enableRootScrolling as t, getUniqueString as n, hasSlotContent as r, returnFirstEl as i } from "../../common/utils/index.js";
import { t as a } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import o from "../../common/mixins/mode.js";
import { NOTICE_KINDS as s } from "../notice/notice-constants.js";
import c from "../text/text.js";
import { DialtoneLocalization as l } from "../../localization/index.js";
import u from "../button/button.js";
import d from "../../shared/sr_only_close_button.js";
import { MODAL_BANNER_KINDS as f, MODAL_KIND_MODIFIERS as p, MODAL_SIZE_MODIFIERS as m } from "./modal-constants.js";
import { Teleport as h, Transition as g, createBlock as _, createCommentVNode as v, createElementBlock as y, createElementVNode as b, createTextVNode as x, createVNode as S, mergeProps as C, normalizeClass as w, openBlock as T, renderSlot as E, resolveComponent as D, toDisplayString as O, vShow as k, withCtx as A, withDirectives as j, withModifiers as M } from "vue";
import { DtIconClose as N } from "@dialpad/dialtone-icons/vue";
//#region components/modal/modal.vue
var P = "button:not(:disabled),[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),details,[tabindex]:not([tabindex=\"-1\"]):not(:disabled):not([aria-disabled=\"true\"])", F = {
	compatConfig: { MODE: 3 },
	name: "DtModal",
	components: {
		DtButton: u,
		DtText: c,
		DtIconClose: N,
		SrOnlyCloseButton: d
	},
	mixins: [o],
	props: {
		copy: {
			type: String,
			default: ""
		},
		describedById: {
			type: String,
			default: ""
		},
		labelledById: {
			type: String,
			default: function() {
				return n();
			}
		},
		open: {
			type: Boolean,
			default: !1
		},
		headerText: {
			type: String,
			default: void 0
		},
		bannerHeaderText: {
			type: String,
			default: void 0
		},
		kind: {
			type: String,
			default: "default",
			validator: (e) => Object.keys(p).includes(e)
		},
		size: {
			type: String,
			default: "default",
			validator: (e) => Object.keys(m).includes(e)
		},
		modalClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		dialogClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		bannerKind: {
			type: String,
			default: "warning",
			validator(e) {
				return s.includes(e);
			}
		},
		bannerClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		footerClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		showClose: {
			type: Boolean,
			default: !0
		},
		closeOnClick: {
			type: Boolean,
			default: !0
		},
		fixedHeaderFooter: {
			type: Boolean,
			default: !0
		},
		initialFocusElement: {
			type: [String, HTMLElement],
			default: "first",
			validator: (e) => e === "first" || e instanceof HTMLElement || e.startsWith("#")
		},
		appendTo: {
			type: String,
			default: void 0
		}
	},
	emits: [
		"click",
		"keydown",
		"update:open"
	],
	data() {
		return {
			MODAL_KIND_MODIFIERS: p,
			MODAL_SIZE_MODIFIERS: m,
			MODAL_BANNER_KINDS: f,
			hasSlotContent: r,
			i18n: new l()
		};
	},
	computed: {
		hasFooterSlot() {
			return !!this.$slots.footer;
		},
		bannerKindClass() {
			return f[this.bannerKind];
		},
		closeButtonTitle() {
			return this.i18n.$t("DIALTONE_CLOSE_BUTTON");
		}
	},
	watch: { open(e) {
		this.syncDialogState(e);
	} },
	mounted() {
		this.open && this.syncDialogState(!0);
	},
	beforeUnmount() {
		let e = this.$refs.dialogEl;
		e?.open && (e.close(), t(this.getScrollRoot())), this.previousActiveElement = null;
	},
	methods: {
		getScrollRoot() {
			return i(this.$refs.dialogEl)?.getRootNode()?.host;
		},
		syncDialogState(n) {
			let r = this.$refs.dialogEl;
			r && (n ? (this.previousActiveElement = document.activeElement, r.open || r.showModal(), e(this.getScrollRoot())) : r.open && t(this.getScrollRoot()));
		},
		close() {
			this.$emit("update:open", !1);
		},
		onBackdropClick(e) {
			this.closeOnClick && e.target === e.currentTarget && this.close(), this.$emit("click", e);
		},
		onKeydown(e) {
			this.$emit("keydown", e);
		},
		async onAfterEnter() {
			this.$emit("update:open", !0), await this.setFocusAfterTransition();
		},
		onAfterLeave() {
			let e = this.$refs.dialogEl;
			e?.open && e.close(), this.previousActiveElement?.focus(), this.previousActiveElement = null;
		},
		focusFirstTabbable(e) {
			let t = [...e.querySelectorAll(P)];
			if (!t.length) return;
			let n = t[0];
			n.matches("[type=\"radio\"]:not(:checked)") && (n = t.find((e) => e.checked && e.name === n.name) || n), n.focus({ preventScroll: !0 });
		},
		async setFocusAfterTransition() {
			let e = this.$refs.dialogEl;
			if (e) if (await this.$nextTick(), this.initialFocusElement === "first") this.focusFirstTabbable(e);
			else if (typeof this.initialFocusElement == "string" && this.initialFocusElement.startsWith("#")) {
				let t = e.querySelector(this.initialFocusElement);
				t ? t.focus() : (console.warn("Could not find the element specified in dt-modal prop \"initialFocusElement\". Defaulting to focusing the first element."), this.focusFirstTabbable(e));
			} else this.initialFocusElement instanceof HTMLElement && this.initialFocusElement.focus();
		}
	}
}, I = ["aria-describedby", "aria-labelledby"], L = ["id"];
function R(e, t, n, r, i, a) {
	let o = D("dt-text"), s = D("sr-only-close-button"), c = D("dt-icon-close"), l = D("dt-button");
	return T(), _(h, {
		disabled: !n.appendTo,
		to: n.appendTo
	}, [b("dialog", C({
		ref: "dialogEl",
		class: [
			"d-modal",
			i.MODAL_KIND_MODIFIERS[n.kind],
			i.MODAL_SIZE_MODIFIERS[n.size],
			n.modalClass
		],
		"data-qa": "dt-modal",
		"aria-describedby": n.describedById || void 0,
		"aria-labelledby": n.labelledById
	}, e.modeAttrs, {
		onCancel: t[0] || (t[0] = M((...e) => a.close && a.close(...e), ["prevent"])),
		onClick: t[1] || (t[1] = (...e) => a.onBackdropClick && a.onBackdropClick(...e)),
		onKeydown: t[2] || (t[2] = (...e) => a.onKeydown && a.onKeydown(...e))
	}), [n.open && (i.hasSlotContent(e.$slots.banner) || n.bannerHeaderText) ? (T(), y("div", {
		key: 0,
		"data-qa": "dt-modal-banner",
		class: w([
			"d-modal__banner",
			n.bannerClass,
			a.bannerKindClass
		])
	}, [E(e.$slots, "banner", {}, () => [x(O(n.bannerHeaderText), 1)])], 2)) : v("", !0), S(g, {
		appear: n.open,
		name: "d-modal__dialog",
		onAfterEnter: a.onAfterEnter,
		onAfterLeave: a.onAfterLeave
	}, {
		default: A(() => [j(b("div", { class: w([
			"d-modal__dialog",
			{ "d-modal__dialog--scrollable": n.fixedHeaderFooter },
			n.dialogClass
		]) }, [
			i.hasSlotContent(e.$slots.header) ? (T(), y("div", {
				key: 0,
				id: n.labelledById,
				class: w(["d-modal__header", n.headerClass]),
				"data-qa": "dt-modal-title"
			}, [E(e.$slots, "header")], 10, L)) : (T(), _(o, {
				key: 1,
				id: n.labelledById,
				kind: "headline",
				size: 600,
				strength: "medium",
				density: "100",
				"text-box-trim": "start",
				as: "h2",
				class: "d-modal__header",
				"data-qa": "dt-modal-title"
			}, {
				default: A(() => [x(O(n.headerText), 1)]),
				_: 1
			}, 8, ["id"])),
			i.hasSlotContent(e.$slots.default) ? (T(), y("div", {
				key: 2,
				class: w(["d-modal__content", n.contentClass]),
				"data-qa": "dt-modal-copy"
			}, [E(e.$slots, "default")], 2)) : (T(), y("p", {
				key: 3,
				class: w(["d-modal__content", n.contentClass]),
				"data-qa": "dt-modal-copy"
			}, O(n.copy), 3)),
			a.hasFooterSlot ? (T(), y("footer", {
				key: 4,
				class: w(["d-modal__footer", n.footerClass])
			}, [E(e.$slots, "footer")], 2)) : v("", !0),
			n.showClose ? (T(), _(l, {
				key: 6,
				class: "d-modal__close",
				"data-qa": "dt-modal-close-button",
				size: 300,
				kind: "muted",
				importance: "clear",
				"aria-label": a.closeButtonTitle,
				title: a.closeButtonTitle,
				onClick: a.close
			}, {
				icon: A(({ iconSize: e }) => [S(c, { size: e }, null, 8, ["size"])]),
				_: 1
			}, 8, [
				"aria-label",
				"title",
				"onClick"
			])) : (T(), _(s, {
				key: 5,
				onClose: a.close
			}, null, 8, ["onClose"]))
		], 2), [[k, n.open]])]),
		_: 3
	}, 8, [
		"appear",
		"onAfterEnter",
		"onAfterLeave"
	])], 16, I)], 8, ["disabled", "to"]);
}
var z = /* @__PURE__ */ a(F, [["render", R]]);
//#endregion
export { z as default };

//# sourceMappingURL=modal.js.map